import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExpand"><Path d="M22 3V16H14V14H20V5H5V11H3V3H22Z" fill="currentColor"/><Path d="M18 7V12H16V10.4142L14 12.4142L12.5858 11L14.5858 9H13V7H18Z" fill="currentColor"/><Path d="M12 13V22H2V13H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpand;
